import { render, staticRenderFns } from "./archiveEventList.vue?vue&type=template&id=66cb5359"
import script from "./archiveEventList.vue?vue&type=script&lang=js"
export * from "./archiveEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports